module.exports = __webpack_public_path__ + "img/karaage.b39e836b.jpg";